import { HttpClient } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Pipe({ name: 'authImage' })
export class AuthImagePipe implements PipeTransform {

  constructor(private http: HttpClient, private sanitizer: DomSanitizer) {}

  async transform(src: string): Promise<SafeUrl> {
    
    const imageBlob = await this.http.get(src, {responseType: 'blob'}).toPromise();
    const reader = new FileReader();
    return new Promise((resolve, reject) => {
      reader.onloadend = () => resolve(this.sanitizer.bypassSecurityTrustUrl(reader.result as string));
      reader.readAsDataURL(imageBlob);
    });
  }

}